import { findUrlLocale } from './paths';

// Same key the previous i18n detector used — existing users keep their locale.
const LOCALE_STORAGE_KEY = 'lng';

export const getStoredLocale = (): string | undefined => {
  try {
    return findUrlLocale(localStorage.getItem(LOCALE_STORAGE_KEY) ?? undefined);
  } catch {
    return;
  }
};

export const setStoredLocale = (locale: string) => {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Storage unavailable — re-detected next visit.
  }
};
